// src/context/ScrollContext.js
import { createContext } from 'react';

export const ScrollContext = createContext(null);